import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";

export const Location = styled.h3`
  color: ${(props) => props.theme.color};
  font-size: ${desktop.small};
  font-weight: 400;
  & > span {
    font-weight: 600;
  }
`;

export const ServiceListContainer = styled.div`
  display: flex;
  align-items: center;
  /* position: sticky; */
  /* top: 10vh; */
  justify-content: space-evenly;
  margin: 1vw 0;
`;
interface ActiveType {
  active: boolean;
}
export const SelectService = styled.div<ActiveType>`
  font-size: ${desktop.small};
  font-weight: 500;
  background: ${(props) =>
    props.active ? props.theme.secondaryColor : props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  padding: 0.5vw 1.5vw;
  color: ${(props) => (props.active ? props.theme.white : props.theme.color)};
  width: fit-content;
  cursor: pointer;
  border-radius: 5px;
  :hover {
    box-shadow: none;
  }
`;
export const BigContentContainer = styled.div`
  width: 100%;
  position: sticky;
  height: 75vh;
  overflow-y: auto;
  top: 10vh;
  background: none;
`;
export const FilterContainer = styled.div`
  background: ${(props) => props.theme.foreground};
  box-shadow: ${(props) => props.theme.subtleShadow};
  width: 100%;
  height: 100%;
  & > h3 {
    color: ${(props) => props.theme.color};
    font-size: ${desktop.small};
    width: 100%;
    box-shadow: ${(props) => props.theme.subtleShadow};
    font-weight: 600;
    margin: 0;
    padding: 0.5vw;
    background: ${(props) => props.theme.background};
  }
  & > div {
    padding: 0.5vw;
  }
`;
export const ClusterContainer = styled.div`
  width: 30px;
  height: 30px;
  background: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.white};
  display: flex;
  cursor: pointer;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
  h2 {
    color: ${(props) => props.theme.white};
    margin: 0;
    font-size: 10px;
  }
  img {
    height: 100%;
    border-radius: 50%;
    width: 100%;
    object-fit: fill;
  }
  @media ${device.laptop} {
    height: 2.5vw;
    width: 2.5vw;
    h2 {
      font-size: 0.7vw;
    }
  }
`;
export const ModalContainer = styled.div`
  padding: 10px;
  & > h3 {
    text-align: center;
    font-weight: 500;
    color: ${(props) => props.theme.color};
    font-size: 16px;
  }
  & > h2 {
    font-weight: 400;
    color: ${(props) => props.theme.color};
    font-size: 14px;
    & > span {
      font-weight: 600;
      color: ${(props) => props.theme.primaryColor};
    }
  }
  & > h4 {
    font-weight: 400;
    color: ${(props) => props.theme.color};

    & > span {
      text-transform: capitalize;
      font-size: 14px;
      color: ${(props) => props.theme.grey};
      font-weight: 500;
    }
  }
  & > button {
    outline: none;
    border: none;
    color: white;
    font-size: 15px;
    background-color: #259b01;
    padding: 0.3vw 1vw;
    border-radius: 5px;
    cursor: pointer;
  }
  @media ${device.laptop} {
    padding: 1vw;
    & > h3 {
      font-size: ${desktop.normal};
    }
    & > h2 {
      font-size: ${desktop.small};
    }
    & > h4 {
      font-size: ${desktop.small};
      & > span {
        font-size: ${desktop.small};
      }
    }
    & > button {
      font-size: ${desktop.normal};
    }
  }
`;

export const ClusterComponent = styled.div`
  background: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.white};
  display: flex;
  align-items: center;
  border-radius: 50%;
`;
export const UserImage = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  @media ${device.laptop} {
    height: 5vw;
    width: 5vw;
  }
`;

export const Toggler = styled.div`
  display: flex;
  align-items: center;
  & > h3 {
    margin: 0 10px 0 0;
    font-size: ${desktop.small};
    color: ${(props) => props.theme.color};
    font-weight: 400;
  }
`;

export const UserList = styled.div`
  padding: 10px;
  border-bottom: ${(props) => `1px solid ${props.theme.subtleBlack}`};
  display: flex;
  width: 100%;
  /* background-color: red; */
  align-items: center;
  & > img {
    height: 50px;
    flex-shrink: 0;
    width: 50px;
    border-radius: 50%;
  }
  & > h3 {
    font-size: 20px;
    color: ${(props) => props.theme.grey};
    align-self: center;
    margin-left: auto;
    cursor: pointer;
  }
  & > button {
    outline: none;
    border: none;
    cursor: pointer;
    font-size: 15px;
    padding: 5px;
    border-radius: 3px;
  }
  & > div {
    padding: 0 10px;
    cursor: pointer;
    h1 {
      margin: 0;
      color: ${(props) => props.theme.color};
      font-weight: 500;
      font-size: 17px;
      text-transform: capitalize;
    }
    h2 {
      margin: 0;
      color: ${(props) => props.theme.grey};
      font-weight: 400;
      font-size: 13px;
      /* text-transform: capitalize; */
    }
  }
  :last-child {
    border: none;
  }
  @media ${device.laptop} {
    padding: 0.5vw 0.5vw;
    & > img {
      height: 4vw;
      width: 4vw;
      border-radius: 50%;
    }
    & > h3 {
      font-size: 1.8vw;
      color: ${(props) => props.theme.grey};
      align-self: center;
      margin-left: auto;
      cursor: pointer;
    }
    & > div {
      padding: 0 0.8vw;
      cursor: pointer;
      h1 {
        margin: 0;
        color: ${(props) => props.theme.color};
        font-weight: 500;
        font-size: ${desktop.normal};
        text-transform: capitalize;
      }
      h2 {
        margin: 0;
        color: ${(props) => props.theme.grey};
        font-weight: 400;
        font-size: ${desktop.small};
        /* text-transform: capitalize; */
      }
    }
  }
`;
